import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderSearch02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M12.084 19.941H4.8a2.4 2.4 0 0 1-2.4-2.4V5.258a1.2 1.2 0 0 1 1.2-1.2h5.718l2.765 2.954H20.4a1.2 1.2 0 0 1 1.2 1.2V11.4m-1.8 7.2 1.2 1.2m-.6-3.6a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default SvgFolderSearch02;
